<template>
        <div class="d-flex align-items-center mt-md-n2" v-if="profile">
            <blockie :address="public_key" v-if="public_key"/>
            <p class="m-l-10 mt-3">{{profile.name | capitalize}}</p>
        </div>
</template>

<script>
    import Blockie from "../common/Blockie.vue";

    export default {
        name: "ProfileByPublicKey",
        components: { Blockie },
        props: ['public_key'],
        watch: {
            public_key: function (nv, ov) {
                if (nv) {

                }
            }
        },
        data() {
            return {
                profile: null
            }
        },
        mounted() {
            this.getProfile();
        },
        methods: {
            async getProfile() {
                try {
                    let {data} = await this.$accounts.post(`accounts/org/by_public_keys`, {
                        pub_keys: [this.public_key]
                    });
                    this.profile = data.orgs.length > 0 ? data.orgs[0] : null;
                } catch (e) {

                }
            }
        }
    }
</script>

<style scoped>

</style>
